import { Carousel, type CarouselApi, CarouselContent, CarouselItem } from "@/components/ui/carousel";
import { cn } from "@roman/shared/utils";
import Autoplay from "embla-carousel-autoplay";
import { useEffect, useState } from "react";

const banners = [
  {
    id: 1,
    imageURL: "/assets/banners/pc_April_20Mpts_1540x380.png",
    link: "https://half-pressure-b6c.notion.site/1a6941dfbe4081cfbceee6844e4d40d3",
  },
  {
    id: 2,
    imageURL: "/assets/banners/pc_LINE_1540x380.png",
    link: "https://line.me/R/ti/p/@115xdozc",
  },
  {
    id: 3,
    imageURL: "/assets/banners/pc_tomodachi2400p_1540x380.png",
    link: "https://half-pressure-b6c.notion.site/1800-1a6941dfbe4080448f10fba22ab5cba4?pvs=73",
  },
  {
    id: 4,
    imageURL: "/assets/banners/pc_announcement_1540x380.png",
    link: "https://half-pressure-b6c.notion.site/1d1941dfbe40809093aff6867d9d2b9a",
  },
  {
    id: 5,
    imageURL: "/assets/banners/pc_AprilCalendar_1540x380.png",
    link: "https://half-pressure-b6c.notion.site/1c1941dfbe40805eab0adbd8d55738b8?pvs=4",
  },
  {
    id: 6,
    imageURL: "/assets/banners/sp_5vs11_1200x297.png",
    link: "https://half-pressure-b6c.notion.site/5-or-11-1bb941dfbe40809f9f65feb38c0cd8d6?pvs=4",
  },
  {
    id: 7,
    imageURL: "/assets/banners/pc_LIVEbanner_1540x380.png",
    link: "https://half-pressure-b6c.notion.site/1-1b4941dfbe408058902fe8cdd71216d0?pvs=4",
  },
  {
    id: 8,
    imageURL: "/assets/banners/pc_influencer_1540x380.png",
    link: "https://half-pressure-b6c.notion.site/1ab941dfbe4080e39177fd02c29e8f5b",
  },
  {
    id: 9,
    imageURL: "/assets/banners/pc_100万円_1540x380.png",
    link: "https://half-pressure-b6c.notion.site/KDDI-1ad941dfbe4080fdaf53c5405180700f?pvs=4",
  },
];

export const PromotionBanners = () => {
  const [api, setApi] = useState<CarouselApi>();
  const [selectedIndex, setSelectedIndex] = useState(0);

  useEffect(() => {
    if (!api) {
      return;
    }

    api.on("select", () => {
      setSelectedIndex(api.selectedScrollSnap());
    });
  }, [api]);

  return (
    <div className="w-full">
      <Carousel
        setApi={setApi}
        className="w-full"
        opts={{
          loop: true,
        }}
        plugins={[
          Autoplay({
            delay: 3000,
            stopOnInteraction: false,
          }),
        ]}
      >
        <CarouselContent>
          {banners.map((banner) => (
            <CarouselItem key={banner.id} className="w-full">
              <img
                src={banner.imageURL}
                alt="promotion"
                className="w-full h-full cursor-pointer object-contain"
                draggable={false}
                onClick={() => window.open(banner.link, "_blank")}
              />
            </CarouselItem>
          ))}
        </CarouselContent>
      </Carousel>

      <div className="py-2 flex space-x-[13px] justify-center">
        {banners.map((banner, index) => (
          <div
            key={banner.id}
            className={cn(
              "w-[8px] h-[4px] sm:w-[14px] lg:w-[14px] rounded-full bg-disabled cursor-pointer",
              selectedIndex === index && "bg-primary",
            )}
            onClick={() => {
              api?.scrollTo(index);
            }}
          />
        ))}
      </div>
    </div>
  );
};
